































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import { Authority } from '@/apps/ice/model/authority'
import { OrderInfo } from '@/api/product/product'
import { Child } from '@/model/course/course'
import { CollegeProduct } from '@/model/product/collegeProduct'
import { CourseProduct, CourseProductView } from '@/model/product/courseProduct'
import { PageDayPlan, DayPlanOutline, PlanOutline } from '@/model/plan/dayPlan'
import CourseItem from '../course_item.vue'
import moment from 'moment'
import num2Chinese from '@/apps/ice/utils/chinese_num'
import { MyLearn } from '@/model/course/course'

const ModuleStudyPlan = namespace('app-ice/studyPlan')
const ModuleProduct = namespace('app-ice/product')
const ModuleUser = namespace('app-ice/user')

@Component({
  components: {
    CourseItem,
  },
})
export default class StudyPlanAll extends Vue {
  @ModuleUser.State((state) => state.myLearn)
  myLearn?: MyLearn

  @ModuleUser.Getter('currentCourse')
  currentCourse?: Child

  @ModuleStudyPlan.State((state) => state.myClass)
  private myClass!: any
  @ModuleStudyPlan.State((state) => state.allPlan)
  private allPlan!: Array<PageDayPlan>

  @ModuleProduct.Action('fetchPlanProductList')
  fetchPlanProductList!: Function
  @ModuleProduct.State((state) => state.planProductList)
  planProductList?: Array<CourseProductView>
  @ModuleProduct.State((state) => state.orderInfo)
  private orderInfo?: OrderInfo[]

  @Prop()
  private authority!: Authority

  moment: any = moment
  num2Chinese: any = num2Chinese

  findProduct(course: any) {
    if (course.id === 'e2') {
      debugger
    }
    if (this.planProductList) {
      const c = this.planProductList.find(
        //@ts-ignore
        (product) => product.courseId === course.courseId
      )
      return c
    }
  }

  weeks: Array<any> = []
  @Watch('allPlan')
  onChange() {
    if (this.allPlan) {
      const weeks: Array<any> = []
      const courseIds = new Set()
      this.allPlan.forEach((plan: PageDayPlan, pIndex: number) => {
        if (plan.dayPlanOutlines) {
          let weekIndex: number = 0
          let week: any
          if (pIndex === 0 || weeks.length === 0) {
            week = {
              start: plan.planDay,
              end: moment(plan.planDay).add(7, 'days').format('YYYY-MM-DD'),
            }
          }
          weeks.forEach((w: any, wIndex: number) => {
            const diff = moment(plan.planDay).diff(w.start, 'days', true)

            if (diff > 0 && diff < 7) {
              week = w
              weekIndex = wIndex
            } else if (diff < 0 || diff >= 7) {
              week = {
                start: plan.planDay,
                end: moment(plan.planDay).add(7, 'days').format('YYYY-MM-DD'),
              }
              weekIndex = weeks.length
            }
          })

          plan.dayPlanOutlines.forEach((dayPlanOutline: DayPlanOutline) => {
            courseIds.add(dayPlanOutline.courseId)
            if (!week.courses) {
              week.courses = []
            }
            if (
              week.courses.every(
                (c: DayPlanOutline) => c.courseId !== dayPlanOutline.courseId
              )
            ) {
              // week.courses.push({ ...dayPlanOutline, actived: plan.actived })

              const actived =
                this.myLearn &&
                this.myLearn.myOutlines!.some(
                  (o: any) => o.courseId === dayPlanOutline.courseId
                )

              week.courses.push({ courseId: dayPlanOutline.courseId, actived })
            }
          })
          weeks[weekIndex] = week
        }
      })
      this.fetchPlanProductList(Array.from(courseIds.values()))
      // console.log(weeks)
      this.weeks = weeks
    }
  }

  /**
   * 获取最晚过期时间
   * 于 2020-06-29
   */
  get lastestExpiryDate() {
    if (this.orderInfo) {
      const orderInfo = this.orderInfo.sort(
        (order: OrderInfo, next: OrderInfo) => {
          return moment(order.expiryDate).isAfter(next.expiryDate) ? -1 : 1
        }
      )
      return orderInfo[0].expiryDate
    }
    return ''
  }

  lineLight(courses: Array<any>, i: number): boolean {
    if (!courses || courses.length - 2 < i) {
      return false
    }

    const product = this.findProduct(courses[i])
    const nextProduct = this.findProduct(courses[i + 1])
    if (!product || !nextProduct) {
      return false
    }
    const curFinish = !!product.myCourse && product.myCourse!.process >= 100
    const nextFinish =
      !!nextProduct.myCourse && nextProduct.myCourse!.process >= 100

    const curProductMark =
      curFinish ||
      (!!this.currentCourse && product.courseId === this.currentCourse.id)
    const nextProductMark =
      nextFinish ||
      (!!this.currentCourse && nextProduct.courseId === this.currentCourse.id)

    return curProductMark && nextProductMark
  }

  isSame(dateStr: string) {
    return moment(dateStr).isSame(moment(), 'day')
  }
}
